import React from 'react';
import LocalizedStrings from 'react-localization';
import $ from 'jquery';


function ErrorBanner(props) {

  setTimeout(() => {
    $('#error-message').hide();
  }, 5000);

  const strings = new LocalizedStrings({
    ru: {
      txt: 'Произошла ошибка! Попробуйте, пожалуйста, позже',
    },
    ua: {
      txt: 'Виникла помилка! Спробуйте, будь ласка, пізніше',
    },
  });

  strings.setLanguage(props.locale);

  return (
    <div id="error-message" className="error-message">
      <p>{strings.txt}</p>
    </div>
  );
}

export default ErrorBanner;
